module.exports = "/static/assets/3b0dcb09577ef2049a462686a19110b6.png";